export default __webpack_public_path__ + "static/comunicacion-1ace074d1dcb1b7f50eef2c2e2e9fe2b.png";